<template>
  <div class="parentEnd">
    <div class="content">
      <div class="header">
        <i class="el-icon-arrow-left"></i>
        <span class="center">单词速记</span>
        <p class="out" @click="loginout">退出登录</p>
      </div>
      <div class="logo">
        <img src="../../assets/images/parent/logo.png" alt="">
      </div>

      <div
          style="display: flex; padding: 12px; background: #fff8e6; border-left: 4px solid #ffc53d; border-radius: 0 4px 4px 0; margin: 10px 0;">
        <svg-icon :icon="'icon14'" style="margin-right: 10px; color: #fa8c16;"></svg-icon>
        <div>
          <div style="font-weight: bold; font-size: 13px; margin-bottom: 5px;">单词个人版上线啦~</div>
          <div style="font-size: 12px; color: #999;; word-break: break-all;">
            手机端请扫描二维码注册使用:
          </div>
          <!-- 二维码 -->
          <div class="qrcode-container" style="margin: 10px 0 5px; ">
            <canvas ref="qrcodeCanvas"></canvas>
          </div>
          <div style="font-size: 12px; color: #999; text-align: center; word-break: break-all;">
            电脑端请访问: &nbsp;<span style="color: orange;font-size: 13px">{{ wordOnlineUrl }}</span>
          </div>
        </div>
      </div>

      <!-- 新增付费提示条 -->
      <!--      <div v-if="!hasPaidForReport && jxList.length" class="pay-tip-bar" >-->
      <!--        <svg-icon icon="icon21" style="margin-right: 10px; color: #ff9800;"></svg-icon>-->
      <!--        <div>-->
      <!--          <div style="font-weight: bold; font-size: 14px; margin-bottom: 4px;">查看完整学习报告</div>-->
      <!--        </div>-->
      <!--        <van-button type="warning" size="small" @click="showPayDialog" round>立即查看</van-button>-->
      <!--      </div>-->

      <!-- 下拉 / 时间选择 -->
      <div class="select" style="margin-top: 15px;" :style="xsList.length > 1 ? 'height:59vw;' : ''">
        <div class="data" :style="xsList.length > 1 ? 'height:53vw;' : ''">
          <div class="text">
            <p>
              <span> {{ jzobj && jzobj.xsmc || '暂无学生' }} </span>
              <span> ( {{ jzobj && jzobj.bjmc || '暂无班级' }} ) </span>
            </p>
            <p class="btn" :style="bjSetlist.length === 0 ? 'display:none;' : ''" @click="childrenClick">更换孩子</p>
          </div>
        </div>
        <div class="selectbox">
          <el-form>
            <el-form-item label="班级" v-if="xsList.length > 1" size="mini">
              <el-select v-model="parentbjid" placeholder="请选择" @change="selectbjChange(parentbjid,jzobj.xsmc)">
                <el-option v-for="item in xsList" :key="item.bjid" :label="item.bjmc" :value="item.bjid"/>
              </el-select>
            </el-form-item>
            <el-form-item label="集训" size="mini">
              <el-select v-model="parentjxid" placeholder="请选择" @change="selectChange(parentjxid)" style="width: 200px;">
                <el-option v-for="item in jxList" :key="item.jxid" :label="item.jxmc" :value="item.jxid"/>
              </el-select>
            </el-form-item>

          </el-form>
          <p v-show="this.jxobj.yxqq"> 日期范围：{{ yxqfw }} </p>

        </div>

        <div class="rope">
          <div>
            <img style="position:absolute;z-index:9;" src="../../assets/images/parent/img1.png" alt="">
          </div>
          <div>
            <img style="position:absolute;z-index:9;" src="../../assets/images/parent/img1.png" alt="">
          </div>
        </div>
      </div>
      <!-- 集训报告按钮 - 只有有报告时才显示 -->
<!--      <div class="report-btn-wrapper"  v-if="jxList.length">-->
<!--        <div class="report-card" @click="openReport">-->
<!--          <div class="report-icon">-->
<!--            <svg-icon icon="icon19" />-->
<!--          </div>-->
<!--          <div class="report-text">-->
<!--            <span class="title">集训报告</span>-->
<!--            <span class="desc">查看孩子本次集训的详细学习报告</span>-->
<!--          </div>-->
<!--          <div class="report-arrow">-->
<!--            <i class="el-icon-arrow-right"></i>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

      <div class="information" v-if="!jxList.length" style="margin-top:20px;height:50vw;">
        <div class="data data-box" style="height:40vw;">
          <p class="tishi">提示！</p>
          <p class="nothing">您的孩子没有临时班级或者没有参加过集训，暂时没有数据展示，请参加完集训再来看吧！</p>
        </div>
      </div>

      <!-- 总体成绩 -->
      <div class="information" v-if="jxList.length" style="margin-top:15px;">
        <div class="img">
          <img src="../../assets/images/parent/block1.png" alt="">
          <p class="center">总体成绩</p>
        </div>
        <div class="data">
          <div class="databox">
            <div class="dataleft">
              <div>
                <img src="../../assets/images/parent/block2.png" alt="">
                <p>累计学习时长</p>
                <p>{{ ztcjObj.ljxxsc || 0 + '分' }}</p>
              </div>
              <div>
                <img src="../../assets/images/parent/block3.png" alt="">
                <p>学习单词总数</p>
                <p>{{ ztcjObj.xxdczs || 0 }}个</p>
              </div>
            </div>
            <div class="dataright">
              <img src="../../assets/images/parent/block4.png" alt="">
              <div class="rightbox">
                <p>整体情况</p>
                <div id="meter"></div>
                <p> {{ ybpval }} </p>
              </div>
            </div>
          </div>
        </div>
        <div class="rope">
          <div>
            <img style="position:absolute;z-index:9;" src="../../assets/images/parent/img1.png" alt="">
          </div>
          <div>
            <img style="position:absolute;z-index:9;" src="../../assets/images/parent/img1.png" alt="">
          </div>
        </div>
      </div>
      <!-- 学情分析 -->
      <div class="information" v-if="jxList.length" style="margin-top: 15px;">
        <div class="img">
          <img src="../../assets/images/parent/block1.png" alt="">
          <p class="center">学情分析</p>
        </div>
        <div class="data">
          <el-table ref="table" class="parenttable" :data="tableDate" border
                    :header-cell-style="{background:'#F1F8FF',color:'#333','text-align':'center'}">
            <el-table-column prop="timulx" width="80" label="题目类型" align="center"/>
            <el-table-column prop="tmsl" width="70" label="正确数" align="center"/>
            <el-table-column prop="tmzql" width="70" label="正确率" align="center">
              <template slot-scope="scope">
                {{ scope.row.tmzql }}%
              </template>
            </el-table-column>
            <el-table-column prop="avggs" label="班级平均数" align="center"/>
          </el-table>
        </div>
        <div class="rope">
          <div>
            <img style="position:absolute;z-index:9;" src="../../assets/images/parent/img1.png" alt="">
          </div>
          <div>
            <img style="position:absolute;z-index:9;" src="../../assets/images/parent/img1.png" alt="">
          </div>
        </div>
      </div>
      <!-- 错词本 -->
      <div class="information" v-if="jxList.length" style="margin-top: 15px;">
        <div class="img">
          <img src="../../assets/images/parent/block1.png" alt="">
          <p class="center">错词本</p>
        </div>
        <div class="data" style="padding: 12px; overflow: hidden;">
          <!-- 错词统计卡片 -->
          <div class="error-stats">
            <div class="stat-item">
              <span class="stat-value">{{ errorStats.totalCount }}</span>
              <span class="stat-label">总错词数</span>
            </div>
            <div class="stat-item">
              <span class="stat-value">{{ errorStats.totalErrorTimes }}</span>
              <span class="stat-label">总出错次数</span>
            </div>
          </div>

          <!-- 错词列表 -->
          <div class="error-list" v-if="errorWordList.length">
            <van-cell
                v-for="(item, index) in errorWordList"
                :key="index"
                is-link
                @click="showWordDetail(item)"
            >
              <template #title>
                <div class="word-title">
                  <span class="word-name">{{ item.dcmc }}</span>
                  <span class="error-count">出错 {{ item.cccs }} 次</span>
                </div>
              </template>
              <template #label>
                <div class="word-info">
                  <span>来源：{{ item.ccly || '--' }}</span>
                  <span class="margin-left">题型：{{ item.cctx || '--' }}</span>
                </div>
              </template>
            </van-cell>

            <!-- 分页 -->
            <div class="pagination-wrapper">
              <van-pagination
                  v-model="errorWordParams.currentPage"
                  :total-items="errorWordTotal"
                  :items-per-page="errorWordParams.pageSize"
                  :show-page-size="3"
                  @change="handleErrorWordPageChange"
              />
            </div>
          </div>

          <van-empty v-else description="暂无错词记录" :image="emptyImage"/>
        </div>
        <div class="rope">
          <div>
            <img style="position:absolute;z-index:9;" src="../../assets/images/parent/img1.png" alt="">
          </div>
          <div>
            <img style="position:absolute;z-index:9;" src="../../assets/images/parent/img1.png" alt="">
          </div>
        </div>
      </div>

      <!-- 错词详情弹窗 -->
      <van-action-sheet v-model="showWordDetailSheet" :title="currentWord.dcmc || '单词详情'" round>
        <div class="word-detail-content">
          <div class="detail-info">
            <div class="info-row">
              <span class="label">单词：</span>
              <span class="value">{{ currentWord.dcmc }}</span>
            </div>
            <div class="info-row">
              <span class="label">出错次数：</span>
              <span class="value error-text">{{ currentWord.cccs }} 次</span>
            </div>
            <div class="info-row">
              <span class="label">错词来源：</span>
              <span class="value">{{ currentWord.ccly || '--' }}</span>
            </div>
            <div class="info-row">
              <span class="label">出错题型：</span>
              <span class="value">{{ currentWord.cctx || '--' }}</span>
            </div>
          </div>
        </div>
      </van-action-sheet>

      <!--日期范围选择区域 -->
      <div class="date-range-wrapper" v-if="jxList.length">
        <div class="date-range-card" @click="showDatePicker = true">
          <div class="date-range-text">
            <span class="label">选择日期范围查询:</span>
            <span class="value" :class="{ 'placeholder': !dateRangeText }">
        {{ dateRangeText || '点击选择日期范围' }}
      </span>
          </div>
          <div class="date-range-arrow">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>

      </div>




      <!-- 单词掌握情况区域 -->
      <div class="information" v-if="jxList.length" style="margin-top: 15px;">
        <div class="img">
          <img src="../../assets/images/parent/block1.png" alt="">
          <p class="center">单词掌握情况</p>
        </div>
        <div class="data chart-data">
          <div id="wordMasteryChart" class="chart-container"></div>
        </div>
        <div class="rope">
          <div>
            <img style="position:absolute;z-index:9;" src="../../assets/images/parent/img1.png" alt="">
          </div>
          <div>
            <img style="position:absolute;z-index:9;" src="../../assets/images/parent/img1.png" alt="">
          </div>
        </div>
      </div>

      <!-- 熟悉度统计 -->
      <div class="information" v-if="jxList.length" style="margin-top: 15px;">
        <div class="img">
          <img src="../../assets/images/parent/block1.png" alt="">
          <p class="center">熟悉度统计</p>
        </div>
        <div class="data">
          <div id="column"></div>
        </div>
        <div class="rope">
          <div>
            <img style="position:absolute;z-index:9;" src="../../assets/images/parent/img1.png" alt="">
          </div>
          <div>
            <img style="position:absolute;z-index:9;" src="../../assets/images/parent/img1.png" alt="">
          </div>
        </div>
      </div>

      <!-- 词汇类型统计区域 -->
      <div class="information" v-if="jxList.length" style="margin-top: 15px;">
        <div class="img">
          <img src="../../assets/images/parent/block1.png" alt="">
          <p class="center">词汇类型统计</p>
        </div>
        <div class="data chart-data">
          <div id="learningTypeChart" class="chart-container"></div>
        </div>
        <div class="rope">
          <div>
            <img style="position:absolute;z-index:9;" src="../../assets/images/parent/img1.png" alt="">
          </div>
          <div>
            <img style="position:absolute;z-index:9;" src="../../assets/images/parent/img1.png" alt="">
          </div>
        </div>
      </div>

      <!-- 进步曲线 -->
      <div class="information" v-if="jxList.length" style="margin-top: 15px;">
        <div class="img">
          <img src="../../assets/images/parent/block1.png" alt="">
          <p class="center">进步曲线</p>
        </div>
        <div class="data">
          <div id="broken"></div>
        </div>
      </div>
      <!-- 学习小贴士 -->
      <div class="information" v-if="jxList.length" style="margin-top: 15px;height:57vw;">
        <div class="img">
          <img src="../../assets/images/parent/block1.png" alt="">
          <p class="center">学习小贴士</p>
        </div>
        <div class="data" style="height:40.2vw;">
          <div class="xts">
            <p class="xxxts" v-for="(item, index) in tipContentList" :key="index">{{ index + 1 + '.' + item }}</p>
          </div>
        </div>
      </div>

      <div class="mask" v-if="flag">
        <div class="title">选择孩子</div>
        <div class="maskbody">
          <div class="box" @click="choice(item)" v-for="item in bjSetlist" :key="item.xsid">
            {{ item.xsmc }}
          </div>
        </div>
      </div>
      <div class="shadow" @click="flag = false" v-if="flag"></div>

      <van-dialog
          @confirm="confirm"
          v-model="loginoutShow"
          title="提示"
          show-cancel-button
          close-on-click-overlay
      >
        <div class="logout-dialog-content">
          <img
              src="../../assets/images/student/sigh.png"
              alt="退出图标"
              class="logout-icon"
          >
          <span class="logout-text">确定要退出登录吗？</span>
        </div>
      </van-dialog>

      <!-- 日期选择器弹窗 -->
      <van-popup v-model="showDatePicker" position="bottom" round>
        <div style="padding: 16px;">
          <div style="display: flex; justify-content: space-between; margin-bottom: 16px;">
            <span>选择开始日期</span>
            <van-button size="small" @click="showDatePicker = false">取消</van-button>
            <van-button size="small" type="primary" @click="confirmDateRange">确定</van-button>
          </div>
          <van-datetime-picker
              v-model="startDate"
              type="date"
              title="选择开始日期"
              :min-date="minDate"
              :max-date="maxDate"
          />
          <div style="margin: 16px 0;">选择结束日期</div>
          <van-datetime-picker
              v-model="endDate"
              type="date"
              title="选择结束日期"
              :min-date="minDate"
              :max-date="maxDate"
          />
        </div>
      </van-popup>

      <!-- 支付弹窗组件 -->
      <VipPaymentModal
          ref="paymentModal"
          :memberInfo="selectedMemberInfo"
          @payment-success="handlePaymentSuccess"
      />
    </div>
  </div>
</template>
<script>
import {parentselect, jxselect, parentxqfx} from "@/api/parent";
import {getStudyAnalysis, getStudytips, getErrorWordList} from "@/api/student";
import {queryVipInformation, getMemberType, newOrder, alipay, weiChatPay, orderStatus} from '@/api/vip'
import * as echarts from "echarts";
import Vue from "vue";
import {BarChart} from "echarts/charts";
import {Dialog, Popup, DatetimePicker} from "vant";
import "vant/lib/index.css";
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
} from "echarts/components";
import {CanvasRenderer} from "echarts/renderers";
import {browserUrl} from '@/utils/index.js'
import {mapState} from "vuex";
import QRCode from 'qrcode'
// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  BarChart,
  CanvasRenderer,
]);
Vue.use(echarts);
Vue.use(Dialog);
Vue.use(Popup);
Vue.use(DatetimePicker);
export default {
  components: {
    VipPaymentModal: (resolve) => {
      require(["@/components/pay/VipPaymentModal.vue"], resolve);
    },
  },
  data() {
    return {
      wordOnlineUrl: '',
      browserUrl: browserUrl,
      // 仪表盘配置
      gaugeOption: {
        series: [
          {
            type: "gauge",
            startAngle: 180,
            endAngle: 0,
            min: 0,
            max: 1,
            splitNumber: 8,
            radius: "100%", // 大小
            axisLine: {
              lineStyle: {
                width: 6,
                color: [
                  [0.26999, "#FDDD60"],
                  [0.72999, "#7CFFB2"],
                  [1, "#3FA0FF"],
                ],
              },
            },
            pointer: {
              icon: "path://M12.8,0.7l12,40.1H0.7L12.8,0.7z",
              length: "20%",
              width: 10,
              offsetCenter: [0, "-60%"],
              itemStyle: {
                color: "auto",
              },
            },
            axisTick: {
              length: 0,
            },
            splitLine: {
              length: 0,
            },
            axisLabel: {
              color: "#464646",
              fontSize: 20,
              distance: -60,
              formatter: function (value) {
              },
            },
            detail: {
              fontSize: 16,
              offsetCenter: [0, "20%"],
              valueAnimation: true,
              formatter: function (value) {
                return null;
              },
              color: "auto",
            },
            data: [
              {
                value: 0,
              },
            ],
          },
        ],
      },
      // 柱状图配置
      categoryOption: {
        color: ["#3FA0FF", "#51CC74", "#FAD444"],
        legend: {
          bottom: "13%",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function (params) {
            let str = params[0].name;
            for (let i = 0; i < params.length; i++) {
              let total =
                  params[i].value.jscsl +
                  params[i].value.shsl +
                  params[i].value.scsl;
              return (
                  str +
                  `<br />熟词:${params[i].value.shsl}个(${total > 0
                      ? ((params[i].value.shsl / total) * 100).toFixed(2)
                      : 0
                  }%)<br />
                            夹生词:${params[i].value.jscsl}个(${total > 0
                      ? ((params[i].value.jscsl / total) * 100).toFixed(2)
                      : 0
                  }%)<br />
                            生词:${params[i].value.scsl}个(${total > 0
                      ? ((params[i].value.scsl / total) * 100).toFixed(2)
                      : 0
                  }%)<br />
                            总计:${total}个`
              );
            }
          },
        },
        dataset: {
          dimensions: ["rq", "熟词", "夹生词", "生词"],
          source: [],
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            left: "9%",
            realtime: true,
            bottom: -5,
            start: 0,
            end: 50, //初始化滚动条
          },
        ],
        xAxis: {
          type: "category",
        },
        yAxis: {
          type: "value",
          min: 0,
          max: 100,
          axisLabel: {
            show: true,
            interval: "auto",
            formatter: "{value}%",
          },
        },
        series: [
          {
            type: "bar",
            label: {
              //柱体上显示数值
              show: true, //开启显示
              position: "top", //在上方显示
              textStyle: {
                //数值样式
                fontSize: "0.6rem",
                color: "#333",
              },
              formatter: function (val) {
                return val.data.total
                    ? Math.round((val.data["熟词"] / 100) * val.data.total) + "个"
                    : "";
              },
            },
          },
          {
            type: "bar",
            label: {
              //柱体上显示数值
              show: true, //开启显示
              position: "top", //在上方显示
              textStyle: {
                //数值样式
                fontSize: "0.6rem",
                color: "#333",
              },
              formatter: function (val) {
                return val.data.total
                    ? Math.round((val.data["夹生词"] / 100) * val.data.total) +
                    "个"
                    : "";
              },
            },
          },
          {
            type: "bar",
            label: {
              //柱体上显示数值
              show: true, //开启显示
              position: "top", //在上方显示
              textStyle: {
                //数值样式
                fontSize: "0.6rem",
                color: "#333",
              },
              formatter: function (val) {
                return val.data.total
                    ? Math.round((val.data["生词"] / 100) * val.data.total) + "个"
                    : "";
              },
            },
          },
        ],
        grid: {
          show: false,
          top: "20%",
          left: "15%",
          right: "18%",
          bottom: "30%",
        },
      },
      // 折线图配置
      prokeOption: {
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            left: "9%",
            realtime: true,
            bottom: -5,
            start: 0,
            end: 50, //初始化滚动条
          },
        ],
        yAxis: {
          type: "value",
        },
        tooltip: {
          trigger: "axis",
        },
        series: [
          {
            data: [],
            type: "line",
            showSymbol: false,
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#b8d0ff", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#f0f5ff", // 100% 处的颜色
                  },
                ],
                globalCoord: false, // 缺省为 false
              },
            },
          },
        ],
        grid: {
          show: true,
          top: "20%",
          left: "15%",
          right: "18%",
          bottom: "20%",
        },
      },
      tableDate: [],
      parentXqfxData: {}, // parentxqfx接口的完整结果数据
      options: [
        {jxmc: "集训", jxid: 1},
        {jxmc: "集训", jxid: 2},
      ],
      parentjxid: "", // 集训id
      parentbjid: "", // 班级id
      times: [],
      show: false,
      date: "",
      bjlist: [], // 保存家长数据
      jzobj: {}, // 显示在页面的家长数据
      jxList: [], // 保存集训数据
      jxobj: {}, // 当前选中的集训数据
      ztcjObj: {}, // 总体成绩对象
      currentData: [], // echarts数组
      ybpval: "良", // 仪表盘优良差
      flag: false, // 选择学生弹窗显示隐藏
      bjSetlist: [], // 去重之后的班级
      xsList: [], // 存储一个孩子的多个班级
      loginoutShow: false, // 登出弹窗
      tipContentList: [], // 学习小贴士
      hasPaidForReport: false, // 是否已付费查看报告
      selectedMemberInfo: null, // 选中的会员信息
      // 日期范围选择
      dateRange: [], // 日期范围选择
      dateRangeText: '', // 日期范围显示文本
      showDatePicker: false, // 显示日期选择器
      startDate: '', // 开始日期
      endDate: '', // 结束日期
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(),
      // 错词本相关
      errorWordList: [],
      errorWordTotal: 0,
      errorWordParams: {
        currentPage: 1,
        pageSize: 3000
      },
      errorStats: {
        totalCount: 0,
        totalErrorTimes: 0
      },
      showWordDetailSheet: false,
      currentWord: {}
    };
  },
  computed: {
    yxqfw() {
      if (this.jxobj.yxqq) {
        return (
            this.$utils.timeChange(this.jxobj.yxqq).substring(0, 10) + "-" + this.$utils.timeChange(this.jxobj.yxqz).substring(0, 10)
        );
      } else {
        return "暂无时间";
      }
    },
    ...mapState(['fellow']),
  },
  created() {
    this.queryIfVip()
    this.checkReportPaymentStatus()//检查是否付费
    if (window.location.href.includes('https://word.ideaigc.com/')) {
      this.wordOnlineUrl = 'http://word.ideaigc.com';
    } else if (window.location.href.includes('https://word.idechat.com/')) {
      this.wordOnlineUrl = 'http://word.idechat.com';
    } else {
      this.wordOnlineUrl = 'http://word.idechat.com';
    }
    // 生成二维码
    this.$nextTick(() => {
      this.generateQRCode();
    });
  },
  watch: {
    wordOnlineUrl: {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.generateQRCode();
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    // 生成二维码
    generateQRCode() {
      if (this.$refs.qrcodeCanvas && this.wordOnlineUrl) {
        QRCode.toCanvas(this.$refs.qrcodeCanvas, this.wordOnlineUrl, {
          width: 100,
          height: 100,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#ffffff'
          }
        }, (error) => {
          if (error) {
            console.error('二维码生成失败:', error);
          }
        });
      }
    },
    // 检查报告付费状态
    checkReportPaymentStatus() {
      // 从localStorage获取付费状态
      const paidStatus = localStorage.getItem('report_paid_status')
      if (paidStatus === 'true') {
        this.hasPaidForReport = true
      }
    },

    // 保存付费状态
    saveReportPaymentStatus() {
      localStorage.setItem('report_paid_status', 'true')
      this.hasPaidForReport = true
    },

    // 显示支付弹窗
    async showPayDialog() {
      // 获取会员套餐列表
      try {
        const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
        const {result} = await getMemberType({hyxt: 5, yhid: userInfo.yhid})
        if (result && result.length > 0) {
          // 默认选中第一个套餐
          this.selectedMemberInfo = result[0]
          this.$refs.paymentModal.showModal = true
        } else {
          Dialog.alert({
            message: '暂无可用套餐，请稍后再试',
            confirmButtonText: '确定'
          })
        }
      } catch (error) {
        console.error('获取会员套餐失败', error)
        Dialog.alert({
          message: '获取套餐信息失败，请重试',
          confirmButtonText: '确定'
        })
      }
    },

    // 支付成功回调
    handlePaymentSuccess() {
      this.saveReportPaymentStatus()
      Dialog.alert({
        message: '支付成功！现在可以查看完整报告了',
        confirmButtonText: '确定'
      }).then(() => {
        // 刷新数据
        this.refreshData()
      })
    },

    // 刷新数据
    refreshData() {
      if (this.jxList.length) {
        // 使用当前选择的日期范围
        const startDateStr = this.startDate ? this.formatDate(this.startDate) : '';
        const endDateStr = this.endDate ? this.formatDate(this.endDate) : '';
        this.xqfxFun(startDateStr, endDateStr)
        this.getStudyAnalysisFun(startDateStr, endDateStr)
      }
    },


    async queryIfVip() {
      const vipRes = await queryVipInformation({yhid: JSON.parse(sessionStorage.getItem('userInfo')).yhid});
      if (vipRes && vipRes.result !== undefined && vipRes.result !== null && Object.keys(vipRes.result).length !== 0) {
        const vipResult = vipRes.result;
        if (Object.keys(vipResult).length !== 0) {
          const time = vipResult.sxsj
          this.$store.commit('setVip', true);
          this.$store.commit('setVipTime', time);
        }
      } else {
        this.$store.commit('setVip', false);
      }
    },
    // 确认日期范围选择
    confirmDateRange() {
      if (this.startDate && this.endDate) {
        const startDateStr = this.formatDate(this.startDate);
        const endDateStr = this.formatDate(this.endDate);

        this.dateRangeText = `${startDateStr} 至 ${endDateStr}`;
        this.showDatePicker = false;

        // 调用接口重新获取数据
        this.xqfxFun(startDateStr, endDateStr);
        this.getStudyAnalysisFun(startDateStr, endDateStr);
      }
    },

    // 格式化日期为 YYYY-MM-DD
    formatDate(date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    // 设置默认日期范围为集训日期范围
    setDefaultDateRange() {
      if (this.jxobj && this.jxobj.yxqq && this.jxobj.yxqz) {
        // 将接口返回的日期字符串转换为Date对象
        const startDateStr = this.$utils.timeChange(this.jxobj.yxqq).substring(0, 10);
        const endDateStr = this.$utils.timeChange(this.jxobj.yxqz).substring(0, 10);

        // 设置日期选择器的默认值
        this.startDate = new Date(startDateStr);
        this.endDate = new Date(endDateStr);

        // 设置日期范围显示文本
        this.dateRangeText = `${startDateStr} 至 ${endDateStr}`;
      }
    },
    // 选中孩子
    choice(val) {
      setTimeout(() => {
        this.flag = false;
      }, 500);
      // 点击学生时判断这个学生有没有多个班级，如果有，出现一个选择班级select
      this.xsList = this.bjlist.filter((item) => {
        return item.xsid == val.xsid;
      });
      this.parentbjid = this.xsList[0].bjid
      this.jzobj = val;
      this.getjxList();
    },
    // 更换孩子
    childrenClick() {
      this.flag = true;
    },
    // 根据班级id拉集训
    getjxList() {
      // 根据班级id拉集训
      jxselect({bjid: this.jzobj && this.jzobj.bjid, yycdid: this.$store.state.yycdid,}).then((res) => {
        if (res.success) {
          this.jxList = res.result;
          if (this.jxList.length) {
            this.parentjxid = this.jxList[0] ? this.jxList[0].jxid : '';
            this.jxobj = this.jxList[0] ? this.jxList[0] : {};
            // 设置默认日期范围为集训日期范围
            this.setDefaultDateRange();
            this.resetErrorWordPage(); // 重置分页
            // 学情分析（使用默认日期范围）
            this.xqfxFun();
            this.getStudyAnalysisFun();
            this.getErrorWordList();
          } else {
            this.parentjxid = ''
            this.jxobj = {}
          }
        }
      });
    },
    //  根据家长手机号拉孩子
    parentSelectFun() {
      parentselect({
        jzsjh: JSON.parse(sessionStorage.getItem("userInfo")).yhm,
        yycdid: this.$store.state.yycdid,
      }).then((res) => {
        if (res.success) {
          this.bjlist = res.result;
          // 孩子没有临时班，jzobj存放学生姓名
          this.jzobj = this.bjlist[0];
          // 返回的数组长度大于1获取去重后学生id数组
          if (res.result.length > 1) {
            this.parentbjid = this.bjlist[0].bjid;
            var setArr = [];
            this.bjlist.forEach((item) => {
              // 拿到所有学生id并去重
              setArr.push(item.xsid);
            });
            setArr = Array.from(new Set(setArr));
            // 获取根据学生id去重后的接口返回值数组
            setArr.forEach((item) => {
              this.bjSetlist.push(this.bjlist.find((ele) => ele.xsid == item));
            });
            // 孩子有临时班，更新jzobj
            this.jzobj = this.bjlist[0];
            this.xsList = this.bjlist.filter((item) => {
              return item.xsid == this.jzobj.xsid;
            });
            // 根据班级id拉集训
          }
          this.getjxList();
        }
      });
    },
    // 其他echarts图表接口
    getStudyAnalysisFun(startDate, endDate) {
      let kssj = this.jxobj.yxqq;
      let jssj = this.jxobj.yxqz;

      // 如果传入了自定义日期范围
      if (startDate && endDate) {
        kssj = startDate + 'T00:00:00.000+0000';
        jssj = endDate + 'T23:59:59.000+0000';
      }

      getStudyAnalysis({
        jxid: this.parentjxid,
        xsid: this.jzobj.xsid,
        kssj: kssj,
        jssj: jssj,
      }).then((res) => {
        this.ztcjObj = {
          ljxxsc: res.result.ljxxsc,
          xxdczs: res.result.xxdczs,
        };
        this.currentData = res.result;
        this.currentData.listStudy.forEach((ele) => {
          ele.total = ele.scsl + ele.jscsl + ele.shsl;
          if (ele.scsl || ele.shsl || ele.jscsl) {
            ele["生词"] = Math.floor((ele.scsl / ele.total) * 10000) / 100;
            ele["熟词"] = Math.floor((ele.shsl / ele.total) * 10000) / 100;
            ele["夹生词"] = Math.floor((ele.jscsl / ele.total) * 10000) / 100;
          }
        });
        if (this.currentData.tyxysl + this.currentData.yyhsl + this.currentData.hyysl + this.currentData.kypcsl <= 0) {
          this.tipContentList = ['加油😄']
        } else if (this.currentData.tyxysl + this.currentData.yyhsl + this.currentData.hyysl + this.currentData.kypcsl === 400) {
          this.tipContentList = ['继续努力😄']
        } else {
          getStudytips({
            hyysl: this.currentData.hyysl,
            kypcsl: this.currentData.kypcsl,
            tyxysl: this.currentData.tyxysl,
            yyhsl: this.currentData.yyhsl,
          }).then(ele => {
            this.tipContentList = ele.result.tipContentList
          })
        }
        //  hyysl: this.currentData.hyysl, kypcsl: this.currentData.kypcsl, tyxysl: this.currentData.tyxysl, yyhsl: this.currentData.yyhsl
        this.setColumn();
        this.setBroken();
        this.setmeter();
      });
    },
    // 学情分析接口
    xqfxFun(startDate, endDate) {
      let kssj = this.jxobj.yxqq;
      let jssj = this.jxobj.yxqz;

      // 如果传入了自定义日期范围
      if (startDate && endDate) {
        kssj = startDate + 'T00:00:00.000+0000';
        jssj = endDate + 'T23:59:59.000+0000';
      }

      parentxqfx({
        bjid: this.jzobj.bjid,
        jxid: this.parentjxid,
        xsid: this.jzobj.xsid,
        kssj: kssj,
        jssj: jssj,
      }).then((res) => {
        let arr = ["看义拼词", "听音辨英", "看义选英", "看英选义"];
        if (res.success) {
          if (res.result) {
            res.result.oneStudyAnalysisResps.forEach((item) => {
              item.timulx = arr[item.tmlx - 1];
            });
            this.tableDate = res.result.oneStudyAnalysisResps;
            // 存储parentxqfx接口的完整结果用于词汇类型统计
            this.parentXqfxData = res.result;
          } else {
            this.tableDate = [];
            this.parentXqfxData = {};
          }
          this.setColumn();
          this.setLearningTypeChart(); // 更新词汇类型统计图表
        } else {
          this.$message.warning(res.resultDesc);
        }
      });
    },
    // 确认退出
    confirm() {
      sessionStorage.clear()
      window.location.href = this.browserUrl;
    },
    loginout() {
      this.loginoutShow = true;
    },
    // 仪表盘
    setmeter() {
      var myEcharts = echarts.init(document.getElementById("meter"));
      this.gaugeOption.series[0].data[0].value =
          this.currentData.ztqk !== null ? (this.currentData.ztqk + 10) / 100 : 0;
      if (this.gaugeOption.series[0].data[0].value >= 0.73) {
        this.ybpval = "优";
      } else if (
          this.gaugeOption.series[0].data[0].value <= 0.73 &&
          this.gaugeOption.series[0].data[0].value >= 0.27
      ) {
        this.ybpval = "良";
      } else {
        this.ybpval = "差";
      }
      setTimeout(() => {
        myEcharts.setOption(this.gaugeOption);
        window.addEventListener("resize", function () {
          myEcharts.resize();
        });
      }, 500);

      // 创建新的图表
      this.setLearningTypeChart();
      this.setWordMasteryChart();
    },

    // 单词掌握情况
    setWordMasteryChart() {
      const chartDom = document.getElementById('wordMasteryChart');
      if (!chartDom) return;

      this.$nextTick(() => {
        const myChart = echarts.init(chartDom);
        const mastered = this.currentData.yzwsl || 0;
        const unmastered = this.currentData.wzwsl || 0;
        const total = mastered + unmastered;

        const option = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c}个 ({d}%)',
            backgroundColor: 'rgba(0,0,0,0.7)',
            borderWidth: 0,
            textStyle: { color: '#fff', fontSize: 12 }
          },
          legend: {
            orient: 'horizontal',
            bottom: 5,
            left: 'center',
            itemWidth: 20,
            itemHeight: 12,
            textStyle: { fontSize: 12, color: '#666' }
          },
          series: [
            {
              name: '单词掌握情况',
              type: 'pie',
              radius: ['45%', '70%'],
              center: ['50%', '45%'],
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 8,
                borderColor: '#fff',
                borderWidth: 2
              },
              label: {
                show: true,
                position: 'outside',
                // 修改：显示数量和百分比
                formatter: '{b}: {c}个',
                fontSize: 12,
                lineHeight: 16
              },
              labelLine: {
                length: 10,
                length2: 10,
                smooth: true
              },
              emphasis: {
                scale: true,
                label: { show: true, fontSize: 13, fontWeight: 'bold' }
              },
              data: [
                { value: mastered, name: '已掌握', itemStyle: { color: '#51CC74' } },
                { value: unmastered, name: '未掌握', itemStyle: { color: '#FFA54D' } }
              ]
            }
          ],
          // 中心显示总数
          graphic: [
            {
              type: 'text',
              left: 'center',
              top: '48%',
              style: {
                text: `${total}`,
                fill: '#333',
                fontSize: 22,
                fontWeight: 'bold'
              },
              invisible: total === 0
            },
            {
              type: 'text',
              left: 'center',
              top: '56%',
              style: {
                text: '总单词数',
                fill: '#999',
                fontSize: 11
              },
              invisible: total === 0
            }
          ]
        };

        myChart.setOption(option);
        window.addEventListener('resize', () => myChart.resize());
      });
    },

    // 词汇类型统计
    setLearningTypeChart() {
      const chartDom = document.getElementById('learningTypeChart');
      if (!chartDom) return;

      this.$nextTick(() => {
        const myChart = echarts.init(chartDom);
        const dataList = [
          { name: '看义拼词', value: this.parentXqfxData.kypcsl || 0, color: '#3FA0FF' },
          { name: '听音选英', value: this.parentXqfxData.tyxysl || 0, color: '#51CC74' },
          { name: '汉译英', value: this.parentXqfxData.hyysl || 0, color: '#FAD444' },
          { name: '英译汉', value: this.parentXqfxData.yyhsl || 0, color: '#FF8A65' }
        ];
        const total = dataList.reduce((sum, item) => sum + item.value, 0);

        const option = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c}次 ({d}%)',
            backgroundColor: 'rgba(0,0,0,0.7)',
            borderWidth: 0,
            textStyle: { color: '#fff', fontSize: 12 }
          },
          legend: {
            orient: 'horizontal',
            bottom: 5,
            left: 'center',
            itemWidth: 20,
            itemHeight: 12,
            textStyle: { fontSize: 11, color: '#666' },
            formatter: (name) => {
              const maxLen = 8;
              return name.length > maxLen ? name.slice(0, maxLen) + '...' : name;
            }
          },
          series: [
            {
              name: '词汇类型统计',
              type: 'pie',
              radius: ['45%', '68%'],
              center: ['50%', '45%'],
              avoidLabelOverlap: true,
              itemStyle: {
                borderRadius: 8,
                borderColor: '#fff',
                borderWidth: 2
              },
              label: {
                show: true,
                position: 'outside',
                // 修改：显示数量和百分比
                formatter: (params) => {
                  return `${params.name}: ${params.value}次`;
                },
                fontSize: 11,
                lineHeight: 15
              },
              labelLine: {
                length: 8,
                length2: 8,
                smooth: true
              },
              emphasis: {
                scale: true,
                label: { show: true, fontSize: 12, fontWeight: 'bold' }
              },
              data: dataList
            }
          ],
          // 中心显示总次数
          graphic: [
            {
              type: 'text',
              left: 'center',
              top: '48%',
              style: {
                text: `${total}`,
                fill: '#333',
                fontSize: 22,
                fontWeight: 'bold'
              },
              invisible: total === 0
            },
            {
              type: 'text',
              left: 'center',
              top: '56%',
              style: {
                text: '总练习次数',
                fill: '#999',
                fontSize: 11
              },
              invisible: total === 0
            }
          ]
        };

        myChart.setOption(option);
        window.addEventListener('resize', () => myChart.resize());
      });
    },
    // 柱状图
    setColumn() {
      var myEcharts = echarts.init(document.getElementById("column"));
      this.categoryOption.dataset.source = this.currentData.listStudy;
      setTimeout(() => {
        myEcharts.setOption(this.categoryOption);
        window.addEventListener("resize", function () {
          myEcharts.resize();
        });
      }, 500);
    },
    // 折线图
    setBroken() {
      var myEcharts = echarts.init(document.getElementById("broken"));
      this.prokeOption.xAxis.data = this.currentData.rqList;
      this.prokeOption.series[0].data = this.currentData.mrdcsList;
      setTimeout(() => {
        myEcharts.setOption(this.prokeOption);
        window.addEventListener("resize", function () {
          myEcharts.resize();
        });
      }, 500);
    },
    // 集训change
    selectChange(val) {
      this.jxobj = this.jxList.find((item) => {
        return item.jxid == val;
      });
      // 使用当前选择的日期范围
      const startDateStr = this.startDate ? this.formatDate(this.startDate) : '';
      const endDateStr = this.endDate ? this.formatDate(this.endDate) : '';
      this.xqfxFun(startDateStr, endDateStr);
      this.getStudyAnalysisFun(startDateStr, endDateStr);
      this.getErrorWordList();
    },
    // 班级change
    selectbjChange(val, mc) {
      this.jzobj = this.bjlist.find((item) => {
        return item.bjid == val && item.xsmc == mc;
      });
      this.getjxList();
    },
    // 获取错词列表
    async getErrorWordList() {
      try {
        if (!this.jzobj?.xsid || !this.parentjxid) {
          console.log('缺少必要参数，无法获取错词列表')
          return
        }

        const params = {
          bjid: this.jzobj.bjid,
          xsid: this.jzobj.xsid,
          lyid: this.parentjxid,
          currentPage: this.errorWordParams.currentPage,
          pageSize: this.errorWordParams.pageSize
        }
        const res = await getErrorWordList(params)
        if (res.success) {
          this.errorWordList = res.result.list.map((item, index) => ({
            ...item,
            index: (this.errorWordParams.currentPage - 1) * this.errorWordParams.pageSize + index + 1
          }))
          this.errorWordTotal = res.result.total
          // 计算统计数据
          this.calculateStats(this.errorWordList)
        }
      } catch (error) {
        console.error('获取错词列表失败', error)
      }
    },

    // 计算错词统计数据
    calculateStats(list) {
      this.errorStats.totalCount = list.length
      this.errorStats.totalErrorTimes = list.reduce((sum, item) => sum + (item.cccs || 0), 0)
    },

    // 分页切换
    handleErrorWordPageChange(page) {
      this.errorWordParams.currentPage = page
      this.getErrorWordList()
    },

    // 显示单词详情
    showWordDetail(item) {
      this.currentWord = item
      this.showWordDetailSheet = true
    },
    resetErrorWordPage() {
      this.errorWordParams.currentPage = 1
    },
    async checkReportExists() {
      try {
        const yycdid = sessionStorage.getItem('yycdid') || ''

        const userInfoStr = sessionStorage.getItem('userInfo')
        const userInfo = userInfoStr ? JSON.parse(userInfoStr) : {}

        const token = sessionStorage.getItem('token') || ''
        const jsmc = userInfo?.jsmc || ''
        const realname = userInfo?.realname || ''
        const yhid = userInfo?.yhid || ''
        const yhm = userInfo?.yhm || ''
        const zhid = userInfo?.zhid || ''
        const zhmc = userInfo?.zhmc || ''

          const params = new URLSearchParams({
            token,
            jsmc,
            realname,
            yhid,
            yhm,
            zhid,
            zhmc,
            yycdid
          }).toString()

          const reportUrl = `https://jxreport.ideaigc.com/report/entry?${params}`
          // 新窗口打开
          window.open(reportUrl, '_blank')
      } catch (error) {
        console.error('检查报告失败', error)
      }
    },
    openReport() {
      this.checkReportExists()
    }
  },
  mounted() {
    //  根据家长手机号拉孩子
    this.parentSelectFun();
  },
};
</script>
<style lang="scss" scoped>
.data-box {
  padding: 5vw;
  font-size: 18px;

  .tishi {
    margin-bottom: 5px;
    font-size: 18px;
  }

  .nothing {
    font-size: 16px;
  }
}

img {
  display: block;
  width: 100%;
  height: 100%;
}

.mask {
  width: 30vh;
  height: 15vh;
  color: #000;
  position: absolute;
  border-radius: 10px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  // background: rgba(89, 144, 255, .1);
  background: #fff;
  z-index: 9;

  .title {
    width: 100%;
    height: 30px;
    font-size: 14px;
    text-align: center;
    line-height: 30px;
    color: #fff;
    background: #5990ff;
    border-radius: 10px 10px 0 0;
  }

  .maskbody {
    width: 80%;
    height: calc(80% - 30px);
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 14px;
    box-sizing: border-box;
    color: #5990ff;

    .box {
      width: 40%;
      float: left;
      margin-left: 10px;
    }

    .box:nth-child(2n) {
      float: right;
    }

    .box:hover {
      transform: scale(1.2);
    }
  }
}

.shadow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 3;
}

.rope {
  height: 15px;
  width: 100%;
  position: absolute;
  bottom: -10px;
  padding: 0 18vw;

  div {
    position: relative;
    float: left;
    width: 8px;
    height: 28px;
  }

  div:nth-child(2) {
    float: right;
  }
}

.center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.rightbox {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding-top: 15%;
  box-sizing: border-box;

  p:nth-child(1) {
    color: #fff;
    font-size: 14px;
    text-align: center;
  }

  #meter {
    width: 20vw;
    height: 20vw;
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translateX(-50%);
  }

  p:nth-child(3) {
    position: absolute;
    bottom: 10%;
    left: 50%;
    transform: translateX(-50%);
    color: #5990ffff;
    font-size: 18px;
  }
}

.parentEnd {
  width: 100%;
  height: 100%;

  .content {
    width: 100%;
    height: 100%;
    background: #5990ff;
    box-sizing: border-box;
    padding: 3vw 2vw;
    overflow-y: auto;
  }

  .header {
    width: 100%;
    height: 30px;
    color: #fff;
    position: relative;

    i {
      position: absolute;
      top: 50%;
      left: 5px;
      transform: translateY(-50%);
      font-weight: 600;
    }

    .out {
      position: absolute;
      top: 50%;
      right: 5px;
      transform: translateY(-50%);
      font-size: 16px;
    }
  }

  .logo {
    width: 100%;
    height: 40vw;
    margin-top: 10px;
    margin-bottom: 15px;
  }

  .information {
    width: 100%;
    height: 90vw;
    background: #425de0;
    position: relative;
    padding: 0 2vw;
    box-sizing: border-box;

    .img {
      width: 50%;
      height: 11vw;
      position: absolute;
      top: 8vw;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1;

      p {
        font-size: 4vw;
        color: #fff;

        span {
          font-size: 2vw;
        }
      }
    }

    .data {
      width: calc(100% - 4vw);
      height: 73vw;
      background: #fff;
      position: absolute;
      bottom: 4vw;
      left: 50%;
      transform: translateX(-50%);
      border-radius: 10px;

      .parenttable {
        position: absolute;
        top: 10vw;
        left: 0;
        right: 0;
        bottom: 20px;
        border-radius: 10px;
        overflow-y: auto;
      }

      .databox {
        width: 100%;
        height: 100%;
        padding: 10vw 2vw 5vw 2vw;

        .dataleft {
          width: 60%;
          height: 100%;
          float: left;

          div {
            height: 47%;
            position: relative;
            color: #fff;

            p:nth-child(2) {
              position: absolute;
              top: 20%;
              left: 8%;
              font-size: 13px;
            }

            p:nth-child(3) {
              position: absolute;
              top: 50%;
              left: 8%;
              font-size: 18px;
            }
          }

          div:nth-child(1) {
            margin-bottom: 6%;
          }
        }

        .dataright {
          position: relative;
          float: right;
          width: 38%;
          height: 100%;
        }
      }
    }
  }

  .select {
    width: 100%;
    height: 43vw;
    background: #425de0;
    position: relative;

    .data {
      width: calc(100% - 4vw);
      height: 37vw;
      background: #fff;
      position: absolute;
      bottom: 2vw;
      left: 50%;
      transform: translateX(-50%);
      border-radius: 10px;
      padding: 5vw;

      .text {
        font-size: 16px;
        font-weight: 600;

        p {
          float: left;
        }

        .btn {
          float: left;
          color: #409eff;
          font-size: 14px;
          margin: 2px 0 0 10px;
        }
      }
    }

    .selectbox {
      padding-top: 18vw;
      width: 100%;
      height: 100%;
      padding-left: 7vw;
      position: relative;
      pointer-events: none;

      p {
        padding: 3px;
        background: rgba(89, 144, 255, 0.6);
        border-radius: 4px;
        color: #fff;
        font-size: 12px;
        position: absolute;
        bottom: 6vw;
      }

      ::v-deep  .el-input__inner {
        height: 30px !important;
        line-height: 30px !important;
      }
    }
  }
}

#column {
  width: 100%;
  height: 100%;
}

#broken {
  width: 100%;
  height: 100%;
}

.el-table::before {
  height: 0;
}

.xts {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 7vw 5vw 0;

  .xxxts {
    font-size: 3.5vw;
    line-height: 5vw;
  }
}


// 新增付费提示条样式
.pay-tip-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #fff8e6 0%, #fff0d4 100%);
  border-radius: 12px;
  padding: 12px 16px;
  margin: 10px 0;
  cursor: pointer;
  border: 1px solid #ffe0b3;

  &:hover {
    background: linear-gradient(135deg, #fff0d4 0%, #ffe8c0 100%);
  }
}

// 报告遮罩层样式
.report-mask {
  position: relative;
  min-height: 400px;

  .mask-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    background: rgba(255, 255, 255, 0.95);
    padding: 30px 20px;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    width: 80%;
    max-width: 320px;
    z-index: 10;

    .mask-title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      margin: 16px 0 8px;
    }

    .mask-desc {
      font-size: 13px;
      color: #666;
      margin-bottom: 24px;
      line-height: 1.5;
    }
  }

  // 模糊效果
  .information {
    filter: blur(4px);
    pointer-events: none;
  }
}

// 错词统计卡片
.error-stats {
  display: flex;
  justify-content: space-around;
  padding: 12px 0 16px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 12px;

  .stat-item {
    text-align: center;
    flex: 1;

    .stat-value {
      display: block;
      font-size: 24px;
      font-weight: bold;
      color: #ff6b6b;
    }

    .stat-label {
      display: block;
      font-size: 12px;
      color: #999;
      margin-top: 4px;
    }
  }
}

// 错词列表
.error-list {
  max-height: 100%;
  overflow-y: auto;

  .word-title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .word-name {
      font-size: 16px;
      font-weight: 500;
      color: #333;
    }

    .error-count {
      font-size: 12px;
      color: #ff6b6b;
      background: #fff0f0;
      padding: 2px 8px;
      border-radius: 12px;
    }
  }

  .word-info {
    display: flex;
    font-size: 12px;
    color: #999;
    margin-top: 4px;

    .margin-left {
      margin-left: 16px;
    }
  }
}

// 分页
.pagination-wrapper {
  padding: 16px 0 8px;
  display: flex;
  justify-content: center;
}

// 详情弹窗样式
.word-detail-content {
  padding: 16px 20px 24px;

  .detail-info {
    background: #f8f9fa;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 24px;

    .info-row {
      display: flex;
      padding: 8px 0;
      border-bottom: 1px solid #eee;

      &:last-child {
        border-bottom: none;
      }

      .label {
        width: 80px;
        color: #666;
        font-size: 14px;
      }

      .value {
        flex: 1;
        color: #333;
        font-size: 14px;

        &.error-text {
          color: #ff6b6b;
          font-weight: 500;
        }
      }
    }
  }

  .action-buttons {
    .van-button {
      height: 44px;
    }
  }
}

.qrcode-container {
  canvas {
    margin: 0 auto;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
}
.date-range-wrapper {
  margin-top: 15px;

  .date-range-title {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    padding-left: 8px;

    span {
      font-size: 14px;
      font-weight: 500;
      color: #ff9800;
    }
  }

  .date-range-card {
    background: linear-gradient(135deg, #fff 0%, #f8f9ff 100%);
    border-radius: 16px;
    padding: 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 12px rgba(89, 144, 255, 0.1);
    border: 1px solid rgba(89, 144, 255, 0.15);

    &:active {
      transform: scale(0.98);
      background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
    }

    .date-range-icon {
      width: 40px;
      height: 40px;
      background: linear-gradient(135deg, #5990ff 0%, #7bacff 100%);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 12px;

      svg-icon {
        width: 22px;
        height: 22px;
        color: #fff;
      }
    }

    .date-range-text {
      flex: 1;
      display: flex;
      flex-direction: column;

      .label {
        font-size: 14px;
        color: orange;
        margin-bottom: 4px;
      }

      .value {
        font-size: 14px;
        font-weight: 500;
        color: #333;

        &.placeholder {
          color: #ccc;
          font-weight: normal;
        }
      }
    }

    .date-range-arrow {
      color: #ccc;
      font-size: 14px;
    }
  }
}
.chart-data {
  padding: 30px 12px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .chart-container {
    padding-top: 10px;
    width: 100%;
    height: 260px;
    margin: 0 auto;
  }
}

#wordMasteryChart,
#learningTypeChart,
#column,
#broken {
  width: 100%;
  height: 100%;
  min-height: 250px;
}
// 报告按钮样式
.report-btn-wrapper {
  margin-top: 15px;

  .report-card {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 16px;
    padding: 14px 16px;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.2);

    &:active {
      transform: scale(0.98);
      box-shadow: 0 2px 10px rgba(102, 126, 234, 0.4);
    }

    .report-icon {
      padding: 5px;
      background: rgba(255, 255, 255, 0.2);
      margin-right: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      border-radius: 20%;
    }

    .report-text {
      flex: 1;

      .title {
        display: block;
        font-size: 16px;
        font-weight: bold;
        color: #fff;
        margin-bottom: 4px;
      }

      .desc {
        display: block;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.8);
      }
    }

    .report-arrow {
      color: rgba(255, 255, 255, 0.8);
      font-size: 16px;
    }
  }
}
.logout-dialog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 0 20px;
  gap: 12px;
}

.logout-icon {
  width: 52px;
  height: 52px;
  object-fit: contain;
}

.logout-text {
  font-size: 15px;
  color: #333;
  font-weight: 500;
}
</style>
